// import { HttpStatusCode } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IRegister } from 'src/app/Shared/model/register.model';
import { HttpStatusCode, ResponseModel } from 'src/app/Shared/model/response.model';
import { ApiDataService } from 'src/app/Shared/services/apidata.service';
import { GetSetService } from 'src/app/Shared/services/getset.serverce';
import { ToastService } from 'src/app/Shared/services/toast.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { AppService } from 'src/app/Shared/services/app.service';
import { Messagetype } from 'src/app/Shared/model/enum';
import { ValidatorService } from 'src/app/Shared/services/validator.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent {
  registerForm : FormGroup
  submitted = false;
  userdata?: IRegister;
  OTPForm : FormGroup;
  showverifyOtpForm = false;
  showverifyOtpFormLogin = false;
  regLoader = false;
  regsubmitted = false;
  isShowLoginForm = true;
  hide = true;
  otp = '';

  constructor(
    public formBuilder: FormBuilder,
    private apiDataService: ApiDataService,
    private toastService: ToastService,
    private getSetService: GetSetService,
    private _snackBar: MatSnackBar,
    private router: Router,
    private appService: AppService,
    private validatorService: ValidatorService,
  ) {
    this.registerForm = this.formBuilder.group({
      firstName: ['',[Validators.required]],
      lastName: ['', [Validators.required]],
      userName: ['',[Validators.required, this.validatorService.userNameValidator]],
      password: ['', [Validators.required, Validators.pattern(
        /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{6,})/
      ),]]
      // refcode: [''],
    });

    this.OTPForm = this.formBuilder.group({
      input1: ['', [Validators.required, Validators.pattern('[0-9]{1}')]],
      input2: ['', [Validators.required, Validators.pattern('[0-9]{1}')]],
      input3: ['', [Validators.required, Validators.pattern('[0-9]{1}')]],
      input4: ['', [Validators.required, Validators.pattern('[0-9]{1}')]],
    });
  }

  ngOnInit(): void {
  }
  public onRegisterFormSubmit(): void {

    this.OTPForm.controls.input1.reset();
    this.OTPForm.controls.input2.reset();
    this.OTPForm.controls.input3.reset();
    this.OTPForm.controls.input4.reset();

    this.regLoader = true;
    this.regsubmitted = true;
    if (this.registerForm?.valid) {
      const registerInfo: IRegister = {
        firstName: this.registerForm.value.firstName,
        lastName: this.registerForm.value.lastName,
        userName: this.registerForm.value.userName,
        password: this.registerForm.value.password,
        otp: '',
        referCode: this.registerForm.value.refcode,
      };

      this.userdata = registerInfo;
      const url = 'user/Registration';
      this.apiDataService
        .postData(url, registerInfo)
        .subscribe((response: ResponseModel<any>) => {
          this.regLoader = false;
          this.regsubmitted = false;
          if (response.status === HttpStatusCode.OK) {
            this.toastService.showToast(
              Messagetype.sucess,
              'Info',
              `${response.statusMessage}`
            );
            this.showverifyOtpForm = true;
            this.getSetService.SetUser(response.data);
            this.appService.setCurrentUserInfo(response.data);
            this.appService.setUserLogin(true);
            this.router.navigateByUrl(`home`);
            // this.router.navigateByUrl(`home`);
            // this._snackBar.open('Welcome To Accofin','', {
            //   duration : 2000,
            //   panelClass: ['blue-snackbar']
            // });
          }
          //  else if (response.status === HttpStatusCode.InternalServerError) {
          //   this.toastService.showToast(
          //     Messagetype.fail,
          //     'Info',
          //     `${response.statusMessage}`
          //   );
          // }
           else {
            this.toastService.showToast(
              Messagetype.fail,
              'Info',
              `${response.statusMessage}`
            );
          }
        });
    }
  }




   //Resend OTP
  //  public resendOtp(): void {
  //   this.OTPForm.controls.input1.reset();
  //   this.OTPForm.controls.input2.reset();
  //   this.OTPForm.controls.input3.reset();
  //   this.OTPForm.controls.input4.reset();

  //   const userName = this.registerForm.controls.userName.value;
  //   const url = `user/Registration?userName=${userName}`;
  //   this.apiDataService.getData(url).subscribe((response: ResponseModel<any>) => {
  //     if (response.status === HttpStatusCode.OK) {
  //       this.toastService.showToast(
  //         Messagetype.sucess,
  //         'Info',
  //         `${response.statusMessage}`
  //       );
  //     } else if (
  //       response.status === HttpStatusCode.BAD_REQUEST ||
  //       response.status === HttpStatusCode.INTERNAL_SERVER_ERROR
  //     ) {
  //       this.toastService.showToast(
  //         Messagetype.fail,
  //         'danger',
  //         `${response.statusMessage}`
  //       );
  //     } else {
  //       this.toastService.showToast(
  //         Messagetype.fail,
  //         'danger',
  //         `${response.statusMessage}`
  //       );
  //     }
  //   });
  // }


  //--------------- OTP form focus input for registration -------------------------------------
  focusInput(e: any, id: any) {
    if (
      (e.keyCode >= 48 && e.keyCode <= 57) ||
      (e.keyCode >= 96 && e.keyCode <= 105)
    ) {
      // 0-9 only

      if (+id < 4) {
        if (
          (<HTMLInputElement>document.getElementById(`input${+id + 1}`))
            .value !== null
        ) {
          document.getElementById(`input${+id + 1}`)?.focus();
        } else {
          document.getElementById(`input${id}`)?.focus();
        }
      }
    }

    if (e.keyCode === 8) {
      if (+id === 1) {
        document.getElementById(`input${id}`)?.focus();
      } else {
        document.getElementById(`input${+id - 1}`)?.focus();
      }
    }

    if (this.getOtp().length === 4) {
      this.verifyOtp();
    }
  }


  // OTP Limit the input to a single digit
  restrictInput(event: any) {
    const inputValue = event.target.value;

    // Remove any non-numeric characters (if any)
    const numericValue = inputValue.replace(/[^0-9]/g, '');

    // Limit the input to a single digit
    if (numericValue.length > 1) {
      event.target.value = numericValue.substring(0, 1);
    }
  }

  getOtp() {
    this.otp = `${this.OTPForm?.value.input1}${this.OTPForm?.value.input2}${this.OTPForm?.value.input3}${this.OTPForm?.value.input4}`;
    return this.otp.trim();
  }


  //------------------------------ Verify Registration OTP-----------------------------------

  public verifyOtp() {
    let data: IRegister = {
      firstName: this.userdata?.firstName,
      lastName: this.userdata?.lastName,
      password: this.userdata?.password,
      userName: this.userdata?.userName,
      referCode: this.userdata?.referCode,
      otp: this.getOtp(),
    };

    const url = `User/Registration`;
    this.apiDataService
      .postData(url, data)
      .subscribe((response: ResponseModel<any>) => {
        if (response.status === HttpStatusCode.OK) {
          //  this._snackBar.open('Welcome To Accofin','', {
          //     duration : 2000,
          //     panelClass: ['blue-snackbar']
          //   });
          if (localStorage.getItem('area') != null) {
          }

          this.getSetService.SetUser(response.data);
          this.appService.setCurrentUserInfo(response.data);
          this.appService.setUserLogin(true);
          this.router.navigateByUrl(`home`);
          this.toastService.showToast(
            Messagetype.sucess,
            'Info',
            `${response.statusMessage}`
          );
          this.OTPForm?.reset();
          document.getElementById('login-area')?.classList.remove('open-form');
        } else if (response.status === HttpStatusCode.INTERNAL_SERVER_ERROR) {
          this.OTPForm?.reset();
          this.toastService.showToast(
            Messagetype.fail,
            'Info',
            `${response.statusMessage}`
          );
        } else if (response.status === HttpStatusCode.BAD_REQUEST) {
          this.OTPForm?.reset();
          this.toastService.showToast(Messagetype.fail, 'Info', `Invalid OTP`);
        }
      });
  }

  public closeAllForm(): void {
    this.isShowLoginForm = true;
    this.showverifyOtpForm = false;
    this.showverifyOtpFormLogin = false;
    // this.isForgetFormShow = false;
    // this.loginForm.reset();
    // this.otpform?.reset();
    this.registerForm?.reset();
    // this.forgetOTPForm.reset();
    // this.isForgetOtpSent = false;
    this.submitted = false;
  }
  get f() {
    return this.registerForm.controls;
  }

    // For hide show password
    showPassword() {
      this.hide = !this.hide;
    }

}
